module.exports = __webpack_public_path__ + "img/grade_image.28a8045f.jpg";